import { render } from "./ArticlesApp.vue?vue&type=template&id=baf2caf0&ts=true"
import script from "./ArticlesApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesApp.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "baf2caf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('baf2caf0', __exports__)) {
    api.reload('baf2caf0', __exports__)
  }
  
  module.hot.accept("./ArticlesApp.vue?vue&type=template&id=baf2caf0&ts=true", () => {
    api.rerender('baf2caf0', render)
  })

}


export default __exports__